webpackJsonp([166785445508668],{

/***/ 418:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Setting off: Rio de Janeiro via Lisbon","path":"/rio-via-lison"}}}]}},"pathContext":{"tag":"travel"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-travel-bc1c1b42252fa075b7a8.js